import { AdminLayout } from "@/views/layouts/AppLayout";
import { MemberRechargePage } from "@/views/pages/lianYunUser/recharge/MemberRechargePage";
import { MemberLevelFormPage, MemberLevelPage } from "@/views/pages/lianYunUser/memberLevel/MemberLevelPage";
import {
    ActivationCodeFormPage,
    ActivationCodePage
} from "@/views/pages/lianYunUser/activationCode/ActivationCodePage";
import {
    InstitutionApplyDetailPage,
    InstitutionApplyPage
} from "@/views/pages/lianYunUser/institutionApply/InstitutionApplyPage";
import { CustomerInfoPage } from "@/views/pages/lianYunUser/infoManage/CustomerInfoPage";
import { CustomerInfoDetailPage } from "@/views/pages/lianYunUser/infoManage/CustomerInfoDetailPage";
import { RechargeManagePage } from "@/views/pages/lianYunUser/rechargeManage/RechargeManagePage";
import { EnterpriseCustomPage } from "@/views/pages/lianYunUser/enterpriseCustom/EnterpriseCustomPage";
import { EnterpriseCustomDetailPage } from "@/views/pages/lianYunUser/enterpriseCustom/EnterpriseCustomDetailPage";
import { EnterpriseCustomFormPage } from "@/views/pages/lianYunUser/enterpriseCustom/EnterpriseCustomFormPage";
import {
    CustomerCommunicationDetailPage,
    CustomerCommunicationFormPage
} from "@/views/pages/lianYunUser/infoManage/CustomerCommunicationFormDetailPage";
import {
    PromotionDetailPage,
    PromotionFormPage,
    PromotionPage
} from "@/views/pages/lianYunUser/promotion/PromotionPage";
import type { AdminRouteObject } from "../index";

/** 用户管理路由，保留 Vue 会员充值记录的旧 URL 和权限契约。 */
export const lianYunUserRoutes: AdminRouteObject = {
    path: "/lianYunUser",
    element: <AdminLayout />,
    handle: { title: "用户管理" },
    children: [
        {
            path: "infoManage",
            element: <CustomerInfoPage />,
            handle: { title: "用户列表", permissions: ["ROLE_SS_CUSTOMER_R", "ROLE_SS_CUSTOMER_W"] }
        },
        {
            path: "userInfo",
            element: <CustomerInfoDetailPage />,
            handle: { title: "查看用户信息", permissions: ["ROLE_SS_CUSTOMER_R"] }
        },
        {
            path: "communicateRecordDetail",
            element: <CustomerCommunicationDetailPage />,
            handle: { title: "用户沟通记录详情", permissions: ["ROLE_SS_CUSTOMER_W"] }
        },
        {
            path: "AddCommunicateRecord",
            element: <CustomerCommunicationFormPage />,
            handle: { title: "新增用户沟通记录", permissions: ["ROLE_SS_CUSTOMER_W"] }
        },
        {
            path: "editCommunicateRecord",
            element: <CustomerCommunicationFormPage />,
            handle: { title: "修改用户沟通记录", permissions: ["ROLE_SS_CUSTOMER_W"] }
        },
        {
            path: "recharge",
            element: <MemberRechargePage />,
            handle: { title: "会员充值记录", permissions: ["ROLE_ORDER_R", "ROLE_ORDER_W"] }
        },
        {
            path: "rechargeManage",
            element: <RechargeManagePage />,
            handle: { title: "会员充值记录", permissions: ["ROLE_ORDER_R", "ROLE_ORDER_W"] }
        },
        {
            path: "enterpriseCustom",
            element: <EnterpriseCustomPage />,
            handle: { title: "企业定制", permissions: ["ROLE_CUSTOMIZED_R", "ROLE_CUSTOMIZED_W"] }
        },
        {
            path: "enterpriseCustom/info/:id",
            element: <EnterpriseCustomDetailPage />,
            handle: { title: "企业定制详情", permissions: ["ROLE_CUSTOMIZED_R", "ROLE_CUSTOMIZED_W"] }
        },
        {
            path: "enterpriseCustom/add",
            element: <EnterpriseCustomFormPage />,
            handle: { title: "新增企业定制", permissions: ["ROLE_CUSTOMIZED_W"] }
        },
        {
            path: "enterpriseCustom/form/:id",
            element: <EnterpriseCustomFormPage />,
            handle: { title: "编辑企业定制", permissions: ["ROLE_CUSTOMIZED_W"] }
        },
        {
            path: "memberLevel",
            element: <MemberLevelPage />,
            handle: { title: "会员等级配置", permissions: ["ROLE_VIP_LEVEL"] }
        },
        {
            path: "memberLevelinfo",
            element: <MemberLevelFormPage />,
            handle: { title: "权限设置", permissions: ["ROLE_VIP_LEVEL"] }
        },
        {
            path: "activationCode",
            element: <ActivationCodePage />,
            handle: { title: "会员激活码", permissions: ["ROLE_CDKEY_R", "ROLE_CDKEY_W"] }
        },
        {
            path: "activationCodeAdd",
            element: <ActivationCodeFormPage />,
            handle: { title: "新增激活码", permissions: ["ROLE_SS_CUSTOMER_W"] }
        },
        {
            path: "promotion",
            element: <PromotionPage />,
            handle: { title: "推广管理", permissions: ["ROLE_PROMO_R", "ROLE_PROMO_W"] }
        },
        {
            path: "promotion/add",
            element: <PromotionFormPage />,
            handle: { title: "新增推广", permissions: ["ROLE_PROMO_W"] }
        },
        {
            path: "promotion/detail/:id",
            element: <PromotionDetailPage />,
            handle: { title: "推广详情", permissions: ["ROLE_PROMO_R", "ROLE_PROMO_W"] }
        },
        {
            path: "institutionApply",
            element: <InstitutionApplyPage />,
            handle: { title: "企业认证审核", permissions: ["ROLE_SS_ORG_REVIEW", "ROLE_SS_ORG_DEAL"] }
        },
        {
            path: "institutionApply/info/:id",
            element: <InstitutionApplyDetailPage />,
            handle: { title: "查看企业认证详情", permissions: ["ROLE_SS_ORG_REVIEW"] }
        },
        {
            path: "institutionApply/audit/:id",
            element: <InstitutionApplyDetailPage auditMode />,
            handle: { title: "审核企业认证", permissions: ["ROLE_SS_ORG_REVIEW"] }
        },
        {
            path: "institutionApply/form/:id",
            element: <InstitutionApplyDetailPage editMode />,
            handle: { title: "修改企业认证", permissions: ["ROLE_SS_ORG_DEAL"] }
        }
    ]
};

export default lianYunUserRoutes;
